import React from 'react';
import {graphql} from 'react-apollo';
import {flowRight as compose} from 'lodash';
import { List, Form, Button } from 'semantic-ui-react'

//utils
import queries from '../../../../src/utils/queries'

import TitDer from '../../../components/funcionales/titder';

class ConfSimVisco2 extends React.Component {
  state={argsDocum: {visco40:0, visco100:0, indice:0}, listAp: [],
    viscoTabla: [{valor:2, valor1:7.994, valor2:6.394},
                {valor:2.1, valor1:8.64, valor2:6.894}, 
                {valor:2.2, valor1:9.309, valor2:7.41}, 
                {valor:2.3, valor1:10, valor2:7.944}, 
                {valor:2.4, valor1:10.71, valor2:8.496}, 
                {valor:2.5, valor1:11.45, valor2:9.063}, 
                {valor:2.6, valor1:12.21, valor2:9.647}, 
                {valor:2.7, valor1:13, valor2:10.25}, 
                {valor:2.8, valor1:13.8, valor2:10.87}, 
                {valor:2.9, valor1:14.63, valor2:11.5}, 
                {valor:3, valor1:15.49, valor2:12.15}, 
                {valor:3.1, valor1:16.36, valor2:12.82}, 
                {valor:3.2, valor1:17.26, valor2:13.51}, 
                {valor:3.3, valor1:18.18, valor2:14.21}, 
                {valor:3.4, valor1:19.12, valor2:14.93}, 
                {valor:3.5, valor1:20.09, valor2:15.66}, 
                {valor:3.6, valor1:21.08, valor2:16.42}, 
                {valor:3.7, valor1:22.09, valor2:17.19}, 
                {valor:3.8, valor1:23.13, valor2:17.97}, 
                {valor:3.9, valor1:24.19, valor2:18.77}, 
                {valor:4, valor1:25.32, valor2:19.56}, 
                {valor:4.1, valor1:26.5, valor2:20.37}, 
                {valor:4.2, valor1:27.75, valor2:21.21}, 
                {valor:4.3, valor1:29.07, valor2:22.05}, 
                {valor:4.4, valor1:30.48, valor2:22.92}, 
                {valor:4.5, valor1:31.96, valor2:23.81}, 
                {valor:4.6, valor1:33.52, valor2:24.71}, 
                {valor:4.7, valor1:35.13, valor2:25.63}, 
                {valor:4.8, valor1:36.79, valor2:26.57},
                {valor:4.9, valor1:38.5, valor2:27.53},
                {valor:5, valor1:40.23, valor2:28.49},
                {valor:5.1, valor1:41.99, valor2:29.46}, 
                {valor:5.2, valor1:43.76, valor2:30.43}, 
                {valor:5.3, valor1:45.53, valor2:31.4}, 
                {valor:5.4, valor1:47.31, valor2:32.37}, 
                {valor:5.5, valor1:49.09, valor2:33.34}, 
                {valor:5.6, valor1:50.87, valor2:34.32}, 
                {valor:5.7, valor1:52.64, valor2:35.29}, 
                {valor:5.8, valor1:54.42, valor2:36.26}, 
                {valor:5.9, valor1:56.2, valor2:37.23}, 
                {valor:6, valor1:57.97, valor2:38.19}, 
                {valor:6.1, valor1:59.74, valor2:39.17}, 
                {valor:6.2, valor1:61.52, valor2:40.15}, 
                {valor:6.3, valor1:63.32, valor2:41.13}, 
                {valor:6.4, valor1:65.18, valor2:42.14}, 
                {valor:6.5, valor1:67.12, valor2:43.18}, 
                {valor:6.6, valor1:69.16, valor2:44.24}, 
                {valor:6.7, valor1:71.29, valor2:45.33}, 
                {valor:6.8, valor1:73.48, valor2:46.44}, 
                {valor:6.9, valor1:75.72, valor2:47.51}, 
                {valor:7, valor1:78, valor2:48.57}, 
                {valor:7.1, valor1:80.25, valor2:49.61}, 
                {valor:7.2, valor1:82.39, valor2:50.69}, 
                {valor:7.3, valor1:84.53, valor2:51.78}, 
                {valor:7.4, valor1:86.66, valor2:52.88}, 
                {valor:7.5, valor1:88.85, valor2:53.98}, 
                {valor:7.6, valor1:91.04, valor2:55.09}, 
                {valor:7.7, valor1:93.2, valor2:56.2}, 
                {valor:7.8, valor1:95.43, valor2:57.31},
                {valor:7.9, valor1:97.72, valor2:58.45},
                {valor:8, valor1:100, valor2:59.6},
                {valor:8.1, valor1:102.3, valor2:60.74}, 
                {valor:8.2, valor1:104.6, valor2:61.89}, 
                {valor:8.3, valor1:106.9, valor2:63.05}, 
                {valor:8.4, valor1:109.2, valor2:64.18}, 
                {valor:8.5, valor1:111.5, valor2:65.32}, 
                {valor:8.6, valor1:113.9, valor2:66.48}, 
                {valor:8.7, valor1:116.2, valor2:67.64}, 
                {valor:8.8, valor1:118.5, valor2:68.79}, 
                {valor:8.9, valor1:120.9, valor2:69.94}, 
                {valor:9, valor1:123.3, valor2:71.1}, 
                {valor:9.1, valor1:125.7, valor2:72.27}, 
                {valor:9.2, valor1:128, valor2:73.42}, 
                {valor:9.3, valor1:130.4, valor2:74.57}, 
                {valor:9.4, valor1:132.8, valor2:75.73}, 
                {valor:9.5, valor1:135.3, valor2:76.91}, 
                {valor:9.6, valor1:137.7, valor2:78.08}, 
                {valor:9.7, valor1:140.1, valor2:79.27}, 
                {valor:9.8, valor1:142.7, valor2:80.46}, 
                {valor:9.9, valor1:145.2, valor2:81.67}, 
                {valor:10, valor1:147.7, valor2:82.87}, 
                {valor:10.1, valor1:150.3, valor2:84.08}, 
                {valor:10.2, valor1:152.9, valor2:85.3}, 
                {valor:10.3, valor1:155.4, valor2:86.51}, 
                {valor:10.4, valor1:158, valor2:87.72}, 
                {valor:10.5, valor1:160.6, valor2:88.95}, 
                {valor:10.6, valor1:163.2, valor2:90.19}, 
                {valor:10.7, valor1:165.8, valor2:91.4}, 
                {valor:10.8, valor1:168.5, valor2:92.65},
                {valor:10.9, valor1:171.2, valor2:93.92},
                {valor:11, valor1:173.9, valor2:95.19},
                {valor:11.1, valor1:176.6, valor2:96.45}, 
                {valor:11.2, valor1:179.4, valor2:97.71}, 
                {valor:11.3, valor1:182.1, valor2:98.97}, 
                {valor:11.4, valor1:184.9, valor2:100.2}, 
                {valor:11.5, valor1:187.6, valor2:101.5}, 
                {valor:11.6, valor1:190.4, valor2:102.8}, 
                {valor:11.7, valor1:193.3, valor2:104.1}, 
                {valor:11.8, valor1:196.2, valor2:105.4}, 
                {valor:11.9, valor1:199, valor2:106.7}, 
                {valor:12, valor1:201.9, valor2:108}, 
                {valor:12.1, valor1:204.8, valor2:109.4}, 
                {valor:12.2, valor1:207.8, valor2:110.7}, 
                {valor:12.3, valor1:210.7, valor2:112}, 
                {valor:12.4, valor1:213.6, valor2:113.3}, 
                {valor:12.5, valor1:216.6, valor2:114.7}, 
                {valor:12.6, valor1:219.6, valor2:116}, 
                {valor:12.7, valor1:222.6, valor2:117.4}, 
                {valor:12.8, valor1:225.7, valor2:118.7}, 
                {valor:12.9, valor1:228.8, valor2:120.1}, 
                {valor:13, valor1:231.9, valor2:121.5}, 
                {valor:13.1, valor1:235, valor2:122.9}, 
                {valor:13.2, valor1:238.1, valor2:124.2}, 
                {valor:13.3, valor1:241.2, valor2:125.6}, 
                {valor:13.4, valor1:244.3, valor2:127}, 
                {valor:13.5, valor1:247.4, valor2:128.4}, 
                {valor:13.6, valor1:250.6, valor2:129.8}, 
                {valor:13.7, valor1:253.8, valor2:131.2},
                {valor:13.8, valor1:257, valor2:132.6},
                {valor:13.9, valor1:260.1, valor2:134},
                {valor:14, valor1:263.3, valor2:135.4},
                {valor:14.1, valor1:266.6, valor2:136.8},
                {valor:14.2, valor1:269.8, valor2:138.2},
                {valor:14.3, valor1:273, valor2:139.6},
                {valor:14.4, valor1:276.3, valor2:141},
                {valor:14.5, valor1:279.6, valor2:142.4},
                {valor:14.6, valor1:283, valor2:143.9},
                {valor:14.7, valor1:286.4, valor2:145.3},
                {valor:14.8, valor1:289.7, valor2:146.8},
                {valor:14.9, valor1:293, valor2:148.2},
                {valor:15, valor1:296.5, valor2:149.7},
                {valor:15.1, valor1:300, valor2:151.2},
                {valor:15.2, valor1:303.4, valor2:152.6},
                {valor:15.3, valor1:306.9, valor2:154.1},
                {valor:15.4, valor1:310.3, valor2:155.6},
                {valor:15.5, valor1:313.9, valor2:157},
                {valor:15.6, valor1:317.5, valor2:158.6},
                {valor:15.7, valor1:321.1, valor2:160.1},
                {valor:15.8, valor1:324.6, valor2:161.6},
                {valor:15.9, valor1:328.3, valor2:163.1},
                {valor:16, valor1:331.9, valor2:164.6},
                {valor:16.1, valor1:335.5, valor2:166.1},
                {valor:16.2, valor1:339.2, valor2:167.7},
                {valor:16.3, valor1:342.9, valor2:169.2},
                {valor:16.4, valor1:346.6, valor2:170.7},
                {valor:16.5, valor1:350.3, valor2:172.3},
                {valor:16.6, valor1:354.1, valor2:173.8},
                {valor:16.7, valor1:358, valor2:175.4},
                {valor:16.8, valor1:361.7, valor2:177},
                {valor:16.9, valor1:365.6, valor2:178.6},
                {valor:17, valor1:369.4, valor2:180.2},
                {valor:17.1, valor1:373.3, valor2:181.7},
                {valor:17.2, valor1:377.1, valor2:183.3},
                {valor:17.3, valor1:381, valor2:184.9},
                {valor:17.4, valor1:384.9, valor2:186.5},
                {valor:17.5, valor1:388.9, valor2:188.1},
                {valor:17.6, valor1:392.7, valor2:189.7},
                {valor:17.7, valor1:396.7, valor2:191.3},
                {valor:17.8, valor1:400.7, valor2:192.9},
                {valor:17.9, valor1:404.6, valor2:194.6},
                {valor:18, valor1:408.6, valor2:196.2},
                {valor:18.1, valor1:412.6, valor2:197.8},
                {valor:18.2, valor1:416.7, valor2:199.4},
                {valor:18.3, valor1:420.7, valor2:201},
                {valor:18.4, valor1:424.9, valor2:202.6},
                {valor:18.5, valor1:429, valor2:204.3},
                {valor:18.6, valor1:433.2, valor2:205.9},
                {valor:18.7, valor1:437.3, valor2:207.6},
                {valor:18.8, valor1:441.5, valor2:209.3},
                {valor:18.9, valor1:445.7, valor2:211},
                {valor:19, valor1:449.9, valor2:212.7},
                {valor:19.1, valor1:454.2, valor2:214.4},
                {valor:19.2, valor1:458.4, valor2:216.1},
                {valor:19.3, valor1:462.7, valor2:217.7},
                {valor:19.4, valor1:467, valor2:219.4},
                {valor:19.5, valor1:471.3, valor2:221.1},
                {valor:19.6, valor1:475.7, valor2:222.8},
                {valor:19.7, valor1:479.7, valor2:224.5},
                {valor:19.8, valor1:483.9, valor2:226.2},
                {valor:19.9, valor1:488.6, valor2:227.7},
                {valor:20, valor1:493.2, valor2:229.5},
                {valor:20.2, valor1:501.5, valor2:233},
                {valor:20.4, valor1:510.8, valor2:236.4},
                {valor:20.6, valor1:519.9, valor2:240.1},
                {valor:20.8, valor1:528.8, valor2:243.5},
                {valor:21, valor1:538.4, valor2:247.1},
                {valor:21.2, valor1:547.5, valor2:250.7},
                {valor:21.4, valor1:556.7, valor2:254.2},
                {valor:21.6, valor1:566.4, valor2:257.8},
                {valor:21.8, valor1:575.6, valor2:261.5},
                {valor:22, valor1:585.2, valor2:264.9},
                {valor:22.2, valor1:595, valor2:268.6},
                {valor:22.4, valor1:604.3, valor2:272.3},
                {valor:22.6, valor1:614.2, valor2:275.8},
                {valor:22.8, valor1:624.1, valor2:279.6},
                {valor:23, valor1:633.6, valor2:283.3},
                {valor:23.2, valor1:643.4, valor2:286.8},
                {valor:23.4, valor1:653.8, valor2:290.5},
                {valor:23.6, valor1:663.3, valor2:294.4},
                {valor:23.8, valor1:673.7, valor2:297.9},
                {valor:24, valor1:683.9, valor2:301.8},
                {valor:24.2, valor1:694.5, valor2:305.6},
                {valor:24.4, valor1:704.2, valor2:309.4},
                {valor:24.6, valor1:714.9, valor2:313},
                {valor:24.8, valor1:725.7, valor2:317},
                {valor:25, valor1:736.5, valor2:320.9},
                {valor:25.2, valor1:747.2, valor2:324.9},
                {valor:25.4, valor1:758.2, valor2:328.8},
                {valor:25.6, valor1:769.3, valor2:332.7},
                {valor:25.8, valor1:779.7, valor2:336.7},
                {valor:26, valor1:790.4, valor2:340.5},
                {valor:26.2, valor1:801.6, valor2:344.4},
                {valor:26.4, valor1:812.8, valor2:348.4},
                {valor:26.6, valor1:824.1, valor2:352.3},
                {valor:26.8, valor1:835.5, valor2:356.4},
                {valor:27, valor1:847, valor2:360.5},
                {valor:27.2, valor1:857.5, valor2:364.6},
                {valor:27.4, valor1:869, valor2:368.3},
                {valor:27.6, valor1:880.6, valor2:372.3},
                {valor:27.8, valor1:892.3, valor2:376.4},
                {valor:28, valor1:904.1, valor2:380.6},
                {valor:28.2, valor1:915.8, valor2:384.6},
                {valor:28.4, valor1:927.6, valor2:388.8},
                {valor:28.6, valor1:938.6, valor2:393},
                {valor:28.8, valor1:951.2, valor2:396.6},
                {valor:29, valor1:963.4, valor2:401.1},
                {valor:29.2, valor1:975.4, valor2:405.3},
                {valor:29.4, valor1:987.1, valor2:409.5},
                {valor:29.6, valor1:998.9, valor2:413.5},
                {valor:29.8, valor1:1011, valor2:417.6},
                {valor:30, valor1:1023, valor2:421.7},
                {valor:30.5, valor1:1055, valor2:432.4},
                {valor:31, valor1:1086, valor2:443.2},
                {valor:31.5, valor1:1119, valor2:454},
                {valor:32, valor1:1151, valor2:464.9},
                {valor:32.5, valor1:1184, valor2:475.9},
                {valor:33, valor1:1217, valor2:487},
                {valor:33.5, valor1:1251, valor2:498.1},
                {valor:34, valor1:1286, valor2:509.6},
                {valor:34.5, valor1:1321, valor2:521.1},
                {valor:35, valor1:1356, valor2:532.5},
                {valor:35.5, valor1:1391, valor2:544},
                {valor:36, valor1:1427, valor2:555.6},
                {valor:36.5, valor1:1464, valor2:567.1},
                {valor:37, valor1:1501, valor2:579.3},
                {valor:37.5, valor1:1538, valor2:591.3},
                {valor:38, valor1:1575, valor2:603.1},
                {valor:38.5, valor1:1613, valor2:615},
                {valor:39, valor1:1651, valor2:627.1},
                {valor:39.5, valor1:1691, valor2:639.2},
                {valor:40, valor1:1730, valor2:651.8},
                {valor:40.5, valor1:1770, valor2:664.2},
                {valor:41, valor1:1810, valor2:676.6},
                {valor:41.5, valor1:1851, valor2:689.1},
                {valor:42, valor1:1892, valor2:701.9},
                {valor:42.5, valor1:1935, valor2:714.9},
                {valor:43, valor1:1978, valor2:728.2},
                {valor:43.5, valor1:2021, valor2:741.3},
                {valor:44, valor1:2064, valor2:754.4},
                {valor:44.5, valor1:2108, valor2:767.6},
                {valor:45, valor1:2152, valor2:780.9},
                {valor:45.5, valor1:2197, valor2:794.5},
                {valor:46, valor1:2243, valor2:808.2},
                {valor:46.5, valor1:2288, valor2:821.9},
                {valor:47, valor1:2333, valor2:835.5},
                {valor:47.5, valor1:2380, valor2:849.2},
                {valor:48, valor1:2426, valor2:863},
                {valor:48.5, valor1:2473, valor2:876.9},
                {valor:49, valor1:2521, valor2:890.9},
                {valor:49.5, valor1:2570, valor2:905.3},
                {valor:50, valor1:2618, valor2:919.6},
                {valor:50.5, valor1:2667, valor2:933.6},
                {valor:51, valor1:2717, valor2:948.2},
                {valor:51.5, valor1:2767, valor2:962.9},
                {valor:52, valor1:2817, valor2:977.5},
                {valor:52.5, valor1:2867, valor2:992.1},
                {valor:53, valor1:2918, valor2:1007},
                {valor:53.5, valor1:2969, valor2:1021},
                {valor:54, valor1:3020, valor2:1036},
                {valor:54.5, valor1:3073, valor2:1051},
                {valor:55, valor1:3126, valor2:1066},
                {valor:55.5, valor1:3180, valor2:1082},
                {valor:56, valor1:3233, valor2:1097},
                {valor:56.5, valor1:3286, valor2:1112},
                {valor:57, valor1:3340, valor2:1127},
                {valor:57.5, valor1:3396, valor2:1143},
                {valor:58, valor1:3452, valor2:1159},
                {valor:58.5, valor1:3507, valor2:1175},
                {valor:59, valor1:3563, valor2:1190},
                {valor:59.5, valor1:3619, valor2:1206},
                {valor:60, valor1:3676, valor2:1222},
                {valor:60.5, valor1:3734, valor2:1238},
                {valor:61, valor1:3792, valor2:1254},
                {valor:61.5, valor1:3850, valor2:1270},
                {valor:62, valor1:3908, valor2:1286},
                {valor:62.5, valor1:3966, valor2:1303},
                {valor:63, valor1:4026, valor2:1319},
                {valor:63.5, valor1:4087, valor2:1336},
                {valor:64, valor1:4147, valor2:1352},
                {valor:64.5, valor1:4207, valor2:1369},
                {valor:65, valor1:4268, valor2:1386},
                {valor:65.5, valor1:4329, valor2:1402},
                {valor:66, valor1:4392, valor2:1419},
                {valor:66.5, valor1:4455, valor2:1436},
                {valor:67, valor1:4517, valor2:1454},
                {valor:67.5, valor1:4580, valor2:1471},
                {valor:68, valor1:4645, valor2:1488},
                {valor:68.5, valor1:4709, valor2:1506},
                {valor:69, valor1:4773, valor2:1523},
                {valor:69.5, valor1:4839, valor2:1541},
                {valor:70, valor1:4905, valor2:1558}
              ]
  }

  handleChange = async (ev)=>{
    ev.preventDefault()

    const argsDocum = this.state.argsDocum
    argsDocum[ev.target.name] = ev.target.value

    this.setState({argsDocum});
  }

  handleSubmit = async (ev)=>{
    let argsDocum = this.state.argsDocum
    // console.log(argsDocum)
    // let alarma1=''
    // let alarma2=''
    // let alarma3=''
    // let corte1=''
    // let corte2=''
    // let corte3=''
    // let mensajeA=''
    // let mensajeC=''
    // let tipo=''
    // let unidad=''
    // let validacion=''
    // let norma=''
    // let descripcion=''
    // let metodo=''

    // if(argsDocum.descrAplicacion && argsDocum.descrPrueba){
    //   if(argsDocum.validacion === "No se compara"){
    //     mensajeA="ESTA PRUEBA NO SE EVALUA, NO TIENE VALORES DE REFERENCIA"
    //   }else{
    //     let prueba=this.props.list2
    //     let listPr = this.props.list2.filter(elemento => elemento.descrPrueba===argsDocum.descrPrueba)

    //     listPr[0].pruebaslab.forEach((valRef, _id) => {
    //       if(valRef.descrAplicacion===argsDocum.descrAplicacion){
    //         if(valRef.valor3Alarma!=='' && valRef.valor3Alarma!==null){
    //           mensajeA = `Mayores que :  ${valRef.valor1Alarma}/${valRef.valor2Alarma}/${valRef.valor3Alarma}`
    //           mensajeC = `Mayores que:  ${valRef.valor1Corte}/${valRef.valor2Corte}/${valRef.valor3Corte}`
    //         }else{
    //           if(valRef.valor2Alarma!=='' && valRef.valor2Alarma!==null){
    //             mensajeA = `Mayores que: ${valRef.valor1Alarma} y Menores que: ${valRef.valor2Alarma}`
    //             mensajeC = `Mayores que: ${valRef.valor1Corte} y Menores que ${valRef.valor2Corte}`
    //           }else{
    //             mensajeA = `Mayores que: ${valRef.valor1Alarma}`
    //             mensajeC = `Mayores que: ${valRef.valor1Corte}`
    //           } 
    //         }
    //       }  
    //     })
    //   }
console.log(argsDocum)
    let visco40 = argsDocum.visco40
    let visco100 = argsDocum.visco100
    let indice = argsDocum.indice 
    let N5 = 0
    let N6 = 0
    let N9 = 0
    let Q5 = 0
    let Q9 = 0
    let N28 = 0
    let N29 = 0
    let Q28 = 0
    let N16 = 0
    let N17 = 0
    let Q16 = 0
    let delta = 0
    let buscar100B = 0
    let buscar100C = 0
    let buscar100D = 0
    let buscar100Bdelta = 0
    let buscar100Cdelta = 0
    let buscar100Ddelta = 0
    let buscar100Bmas = 0
    let buscar100Cmas = 0
    let buscar100Dmas = 0
    let delta100 = 0
    let visco40R = 0
    let visco100R = 0
    let indiceR = 0 
    let J31 = 0
    let J19 = 0
    let salir = 1
    if(parseFloat(visco40)>0 && parseFloat(visco100)>0 && (parseFloat(indice)===0 || indice==='' || indice===null)){
      if(parseFloat(visco100)>20){
        if(parseFloat(visco100)>30){
          delta = 0.5
        }else{
          delta = 0.2
        }
      }else{
        delta = 0.1
      }
      delta100 = parseFloat(visco100) + delta
      console.log(delta, delta100)
      if(parseFloat(visco100)<70){
        if(parseFloat(visco100)>=2){
          const valores100 = this.state.viscoTabla.filter( viscoFind => parseFloat(visco100)>=viscoFind.valor)
          buscar100B=valores100[valores100.length-1].valor
          buscar100C=valores100[valores100.length-1].valor1
          buscar100D=valores100[valores100.length-1].valor2
          console.log(buscar100B, buscar100C, buscar100D)
          const valores100delta = this.state.viscoTabla.filter( viscoFind => delta100>=viscoFind.valor)
          buscar100Bdelta=valores100delta[valores100delta.length-1].valor
          buscar100Cdelta=valores100delta[valores100delta.length-1].valor1
          buscar100Ddelta=valores100delta[valores100delta.length-1].valor2
          console.log(buscar100Bdelta, buscar100Cdelta, buscar100Ddelta)
          const valores100mas = this.state.viscoTabla.filter( viscoFind => parseFloat(visco100)+0.1>=viscoFind.valor)
          buscar100Bmas=valores100mas[valores100mas.length-1].valor
          buscar100Dmas=valores100mas[valores100mas.length-1].valor2
          console.log(buscar100Bmas, buscar100Dmas)
          N5 = (parseFloat(visco100)-(buscar100B))*(buscar100C-buscar100Cdelta)/((buscar100B-buscar100Bdelta))+(buscar100C)
          N6 = (parseFloat(visco100)-(buscar100B))*(buscar100D-buscar100Dmas)/((buscar100B-buscar100Bmas))+(buscar100D)
          Q5 = (parseFloat(visco100)-(buscar100B))*(buscar100D-buscar100Ddelta)/((buscar100B-buscar100Bdelta))+(buscar100D)
        }else{
          
        }
      }else{
        N5 = 0.8353*(parseFloat(visco100)**2)+14.67*parseFloat(visco100)-216
        N6 = 0.1684*(parseFloat(visco100)**2)+11.85*parseFloat(visco100)-97
        Q5 = 0.1684*(parseFloat(visco100)**2)+11.85*parseFloat(visco100)-97
      }
      console.log(N5, N6, Q5)
      let Q6 = (Math.log(Q5)-Math.log(parseFloat(visco40)))/(Math.log(parseFloat(visco100)))
      let N8 = Math.round(((N5-parseFloat(visco40))/(N5-N6))*100)
      console.log(Q6, N8)
      if(N8<=100){
        N9 = N8
      }  
      let Q8 = ((10**Q6)-1)/0.00715+100
      if(Q8>100){
        Q9 = Math.round(Q8)
      }
      if(N9===0){
        indiceR = Q9
      }else{
        indiceR = N9
      }   
      console.log(N9, Q9)
      visco40R = argsDocum.visco40
      visco100R = argsDocum.visco100
    }else{
      if(parseFloat(visco40)>0 && parseFloat(indice)>0 && (parseFloat(visco100)===0 || visco100==='' || visco100===null)){
        salir = 1
        let visco100Temp = 2
        document.body.style.cursor = 'wait'
        do {
          let N32 = 0
          let Q32 = 0
          visco100 = visco100Temp
          if(parseFloat(visco100)>20){
            if(parseFloat(visco100)>30){
              delta = 0.5
            }else{
              delta = 0.2
            }
          }else{
            delta = 0.1
          }
          delta100 = parseFloat(visco100) + delta
          if(parseFloat(visco100)<70){
            if(parseFloat(visco100)>=2){
              const valores100 = this.state.viscoTabla.filter( viscoFind => parseFloat(visco100)>=viscoFind.valor)
              buscar100B=valores100[valores100.length-1].valor
              buscar100C=valores100[valores100.length-1].valor1
              buscar100D=valores100[valores100.length-1].valor2
              const valores100delta = this.state.viscoTabla.filter( viscoFind => delta100>=viscoFind.valor)
              buscar100Bdelta=valores100delta[valores100delta.length-1].valor
              buscar100Cdelta=valores100delta[valores100delta.length-1].valor1
              buscar100Ddelta=valores100delta[valores100delta.length-1].valor2
              const valores100mas = this.state.viscoTabla.filter( viscoFind => parseFloat(visco100)+0.1>=viscoFind.valor)
              buscar100Bmas=valores100mas[valores100mas.length-1].valor
              buscar100Dmas=valores100mas[valores100mas.length-1].valor2
              N28 = (parseFloat(visco100)-(buscar100B))*(buscar100C-buscar100Cdelta)/((buscar100B-buscar100Bdelta))+(buscar100C)
              N29 = (parseFloat(visco100)-(buscar100B))*(buscar100D-buscar100Dmas)/((buscar100B-buscar100Bmas))+(buscar100D)
              Q28 = (parseFloat(visco100)-(buscar100B))*(buscar100D-buscar100Ddelta)/((buscar100B-buscar100Bdelta))+(buscar100D)
            }else{
              
            }
          }else{
            N28 = 0.8353*(parseFloat(visco100)**2)+14.67*parseFloat(visco100)-216
            N29 = 0.1684*(parseFloat(visco100)**2)+11.85*parseFloat(visco100)-97
            Q28 = 0.1684*(parseFloat(visco100)**2)+11.85*parseFloat(visco100)-97
          }
          let Q29 = (Math.log(Q28)-Math.log(parseFloat(visco40)))/(Math.log(parseFloat(visco100)))
          // let N31 = Math.round(((N28-parseFloat(visco40))/(N28-N29))*100)
          let N31 = (((N28-parseFloat(visco40))/(N28-N29))*100).toFixed(10)
          if(parseFloat(N31)<=100){
            N32 = N31
          }  
          let Q31 = ((10**Q29)-1)/0.00715+100
          if(parseFloat(Q31)>100){
            // Q32 = Math.round(Q31)
            Q32 = Q31.toFixed(10)
          }
          if(N32===0){
            J31 = Q32
          }else{
            J31 = N32
          }   
          let J32 = (J31 - parseInt(argsDocum.indice)).toFixed(10)
          // if(parseFloat(visco100)>6 && parseFloat(visco100)<7){
          console.log(visco100, visco100Temp, Q32, N31, N32, parseInt(argsDocum.indice), J31, J32)
          // }
          if(Math.abs(J32) < 1){
            console.log(visco100)
            salir = 0
            visco100R = visco100.toFixed(1)
          }else{
            if(visco100Temp > 200){
              console.log(visco100Temp)
              salir = 0
              visco100R = 0
            }else{
              visco100Temp += 0.08
            }
          }
        } while (salir > 0)
        document.body.style.cursor = 'default'
        visco40R = argsDocum.visco40
        indiceR = argsDocum.indice       
      }else{
        if((parseFloat(visco40)===0 || visco40==='' || visco40===null) && parseFloat(visco100)>0 && parseFloat(indice)>0){
          salir = 1
          let visco40Temp = 2
          document.body.style.cursor = 'wait'
          do {
            let N20 = 0
            let Q20 = 0
            visco40 = visco40Temp
            if(parseFloat(visco100)>20){
              if(parseFloat(visco100)>30){
                delta = 0.5
              }else{
                delta = 0.2
              }
            }else{
              delta = 0.1
            }
            delta100 = parseFloat(visco100) + delta
            if(parseFloat(visco100)<70){
              if(parseFloat(visco100)>=2){
                const valores100 = this.state.viscoTabla.filter( viscoFind => parseFloat(visco100)>=viscoFind.valor)
                buscar100B=valores100[valores100.length-1].valor
                buscar100C=valores100[valores100.length-1].valor1
                buscar100D=valores100[valores100.length-1].valor2
                const valores100delta = this.state.viscoTabla.filter( viscoFind => delta100>=viscoFind.valor)
                buscar100Bdelta=valores100delta[valores100delta.length-1].valor
                buscar100Cdelta=valores100delta[valores100delta.length-1].valor1
                buscar100Ddelta=valores100delta[valores100delta.length-1].valor2
                const valores100mas = this.state.viscoTabla.filter( viscoFind => parseFloat(visco100)+0.1>=viscoFind.valor)
                buscar100Bmas=valores100mas[valores100mas.length-1].valor
                buscar100Dmas=valores100mas[valores100mas.length-1].valor2
                N16 = (parseFloat(visco100)-(buscar100B))*(buscar100C-buscar100Cdelta)/((buscar100B-buscar100Bdelta))+(buscar100C)
                N17 = (parseFloat(visco100)-(buscar100B))*(buscar100D-buscar100Dmas)/((buscar100B-buscar100Bmas))+(buscar100D)
                Q16 = (parseFloat(visco100)-(buscar100B))*(buscar100D-buscar100Ddelta)/((buscar100B-buscar100Bdelta))+(buscar100D)
              }else{
                
              }
            }else{
              N16 = 0.8353*(parseFloat(visco100)**2)+14.67*parseFloat(visco100)-216
              N17 = 0.1684*(parseFloat(visco100)**2)+11.85*parseFloat(visco100)-97
              Q16 = 0.1684*(parseFloat(visco100)**2)+11.85*parseFloat(visco100)-97
            }
            let Q17 = (Math.log(Q16)-Math.log(parseFloat(visco40Temp)))/(Math.log(parseFloat(visco100)))
            let N19 = Math.round(((N16-parseFloat(visco40Temp))/(N16-N17))*100)
            if(N19<=100){
              N20 = N19
            }  
            let Q19 = ((10**Q17)-1)/0.00715+100
            if(Q19>100){
              Q20 = Math.round(Q19)
            }
            if(N20===0){
              J19 = Q20
            }else{
              J19 = N20
            }   
            let J20 = J19 - parseInt(argsDocum.indice)
            if(J20 === 0){
              salir = 0
              visco40R = visco40Temp.toFixed(1)
            }else{
              if(visco40Temp > 2000){
                salir = 0
                visco40R = 0
              }else{
                visco40Temp += 0.1
              }
            }
          } while (salir > 0)
          // console.log(N20, Q20, J19, argsDocum.indice, visco40, salir)
          document.body.style.cursor = 'default'
          visco100R = argsDocum.visco100
          indiceR = argsDocum.indice         
        }else{
          alert("DEBE DIGITAR LOS 2 VALORES CONOCIDOS Y DEJAR EN CERO LA VARIABLE QUE DESEA CALCULAR")
        } 
      } 
    }  
      
    
    let visco40Tit = 'Viscosidad a 40 cSt'
    let visco100Tit = 'Viscosidad a 100 cSt'
    let indiceTit = 'Indice de viscosidad'

      document.getElementById('lbMensaje40Tit').innerHTML = visco40Tit
      let lbMensaje40Tit = document.getElementById('lbMensaje40Tit').innerHTML
      document.getElementById('lbMensaje100Tit').innerHTML = visco100Tit
      let lbMensaje100Tit = document.getElementById('lbMensaje100Tit').innerHTML
      document.getElementById('lbIndiceTit').innerHTML = indiceTit
      let lbIndiceTit = document.getElementById('lbIndiceTit').innerHTML
      
      document.getElementById('lbMensaje40').innerHTML = visco40R
      let lbMensaje40 = document.getElementById('lbMensaje40').innerHTML
      document.getElementById('lbMensaje100').innerHTML = visco100R
      let lbMensaje100 = document.getElementById('lbMensaje100').innerHTML
      document.getElementById('lbIndice').innerHTML = indiceR
      let lbIndice = document.getElementById('lbIndice').innerHTML
    // }else{
    //   alert("Datos incompletos para generar los valores de alarma")
    // }
  }

  

  render(){
    // const {listAp} = this.state;
    let listAp = []

    listAp = this.props.list.filter(elemento => elemento.tipoLub==="Aceite")

    return (

      <div>
        <List selection>
          {/* <TitDer list={list} textBoton1="Empresas" btnNuevo={a010101!==-1?"SI":"NO"} styles={styles} handleClick={handleClick} /> */}
          <TitDer textBoton1="Simulador de Viscosidad " btnNuevo={"NO"} styles={this.props.styles}/>

          {/* <div> */}
          <div className='ui blue inverted raised segment' style={this.props.styles.backGr_1}>
            <Form name="form1" id="form1" onSubmit={(ev)=>this.handleSubmit(ev)}>   
              <label style={{color: 'red'}}>DIGITAR LOS 2 VALORES CONOCIDOS Y DEJAR EN CERO O VACIA LA VARIABLE QUE DESEA CALCULAR</label>
              <p></p>
              <div className="ui three column stackable grid">
                <div className="row container">
                  <div className="column" style={{width: '33%', paddingTop: '0.4em'}}>
                    <Form.Field>
                      <label style={{color: '#000046'}}>Viscosidad a 40 cSt</label>
                      <input type='number' step="0.001" min="0" autoComplete="off" name="visco40" id="visco40" onChange={this.handleChange}/>
                    </Form.Field>
                  </div>
                  <div className="column" style={{width: '33%', paddingTop: '0.4em'}}>
                    <Form.Field>
                      <label style={{color: '#000046'}}>Viscosidad a 100 cSt</label>
                      <input type='number' step="0.001" min="0" autoComplete="off" name="visco100" id="visco100" onChange={this.handleChange}/>
                    </Form.Field>
                  </div>
                  <div className="column" style={{width: '34%', paddingTop: '0.4em'}}>
                    <Form.Field>
                      <label style={{color: '#000046'}}>Indice de viscosidad</label>
                      <input type='number' step="0.001" min="0" autoComplete="off" name="indice" id="indice" onChange={this.handleChange}/>
                    </Form.Field>
                  </div>                
                </div>
              </div>
              <p></p>
              <div className="ui one column stackable grid">
                <div className="row container">
                  <div className="column" style={{width: '100%'}}>
                  <Button style={this.props.styles.confirmar} type='submit' fluid>
                    Ver valores de viscosidad
                  </Button>
                  </div>
                </div>
              </div>
              <p></p>
              <hr></hr>

              <div className="ui two column stackable grid">
                <div className="row container">
                  <div className="column" style={{width: '33%'}}>
                    <Form.Field>
                      <Button style={this.props.styles.titLabel} id="lbMensaje40Tit" type='button' fluid></Button>
                      <Button style={this.props.styles.titLabel2} id="lbMensaje40" type='button' fluid></Button>
                    </Form.Field>
                  </div>
                  <div className="column" style={{width: '33%'}}>
                    <Form.Field>
                      <Button style={this.props.styles.titLabel} id="lbMensaje100Tit" type='button' fluid></Button>
                      <Button style={this.props.styles.titLabel2} id="lbMensaje100" type='button' fluid></Button>
                    </Form.Field>
                  </div>
                  <div className="column" style={{width: '34%'}}>
                    <Form.Field>
                      <Button style={this.props.styles.titLabel} id="lbIndiceTit" type='button' fluid></Button>
                      <Button style={this.props.styles.titLabel2} id="lbIndice" type='button' fluid></Button>
                    </Form.Field>
                  </div>
                </div>
              </div>
            </Form>
          </div>
        </List>
      </div>
    )
  }
};

export default compose( 
  // graphql(queries.query.allPlantaRtes, {name:'allPlantaRtes2',
  //   options: (props) => {return {variables: {tipoqry: `[{$match: {descrEmpresa: 'Seleccionar Empresa...'}}]`}}}}),
  // graphql(queries.mutation.editPlantaEstructura, {name:'editPlantaEstructura'}),
)(ConfSimVisco2)
